// extracted by mini-css-extract-plugin
module.exports = {"container":"Browse_container__2YQiX"};